import LimitIcon from "../../assets/icons/limit_icon.svg";
import InfoIcon from "../../assets/icons/info_icon.svg";
import styles from "./FavouritesLimitMessage.module.scss";
import { FAVOURITES_LIMIT } from "../../constants";

const FAVOURITES_NEAR_LIMIT = FAVOURITES_LIMIT - 1;

const icons = new Map([
  [FAVOURITES_NEAR_LIMIT, InfoIcon],
  [FAVOURITES_LIMIT, LimitIcon],
]);

const iconAltText = new Map([
  [FAVOURITES_NEAR_LIMIT, "Information"],
  [FAVOURITES_LIMIT, "Limit Warning"],
]);

const headings = new Map([
  [FAVOURITES_NEAR_LIMIT, "Favourites capacity almost at limit"],
  [10, "You've reached the favourites limit"],
]);

const messages = new Map([
  [
    FAVOURITES_NEAR_LIMIT,
    "Please delete any unwanted favourites from the favourites list.",
  ],
  [10, "Please delete any unwanted favourites before adding new ones."],
]);

const className = new Map([
  [FAVOURITES_NEAR_LIMIT, styles.nearLimit],
  [FAVOURITES_LIMIT, styles.limit],
]);

export const FavouritesLimitMessage = ({ limit }) => {
  return (
    <div className={`${styles.favouritesLimitMessage} ${className.get(limit)}`}>
      <img
        height={24}
        width={24}
        src={icons.get(limit)}
        alt={iconAltText.get(limit)}
      />
      <div className={styles.details}>
        <h3 className={styles.title}>{headings.get(limit)}</h3>
        <p className={styles.description}>{messages.get(limit)}</p>
      </div>
    </div>
  );
};
